/**
 * Toast Provider
 * Provider che renderizza il container dei toast
 * Sonner gestisce internamente lo stato, quindi questo provider è principalmente
 * un wrapper per il ToastContainer
 */
import { ReactNode } from "react";
import { ToastContainer } from "@/components/base/toast/toast-container";

interface ToastProviderProps {
    children: ReactNode;
}

export function ToastProvider({ children }: ToastProviderProps) {
    return (
        <>
            {children}
            <ToastContainer />
        </>
    );
}
